import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Table, Input } from 'reactstrap';
import { Button } from 'reactstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import AppConfig from 'Constants/AppConfig';
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { editSamLabReport } from 'Actions';

class EditForm extends React.Component {

    static propTypes = {
        classes: PropTypes.object,
        prev: 0,
    };

    UNSAFE_componentWillMount() {

    }

    constructor(props) {
        super(props);
        console.log(props)
        this.nodeRef = React.createRef();
        const cdate = this.props.particularsamlabreport.cdate;
        const parsedDate = moment(cdate, "Do MMMM YYYY").toDate();
        this.state = {
            seldate: parsedDate,
            student: this.props.data.student,
            studentName: this.props.particularsamlabreport.student,
            id: this.props.particularsamlabreport.tsrID || '',
            setup: this.props.particularsamlabreport.tsr_setup || '',
            aimperception: this.props.particularsamlabreport.tsr_aimperception || '',
            aim: this.props.particularsamlabreport.tsr_aim || '',
            faceimpact: this.props.particularsamlabreport.tsr_faceimpact || '',
            facepath: this.props.particularsamlabreport.tsr_facepath || '',
            path: this.props.particularsamlabreport.tsr_path || '',
            contact: this.props.particularsamlabreport.tsr_contact || '',
            launch: this.props.particularsamlabreport.tsr_launch || '',
            acceleration: this.props.particularsamlabreport.tsr_acceleration || '',
            drills: this.props.particularsamlabreport.tsr_drills || '',
            reportname: this.props.particularsamlabreport.tsr_reportname || '',
            selectedFile: [],
            heightProportion: 1600,
            widthProportion: 500
        };
        this.onFileChange = this.onFileChange.bind(this);
    }

    selectdate = (date) => {
        this.setState({ seldate: date });
    }

    handleFormSubmit = () => {
        const data = {
            target: {
                student: this.state.student,
                seldate: moment(new Date(this.state.seldate)).format('yyyy-MM-DD'),
                setup: this.state.setup,
                aimperception: this.state.aimperception,
                aim: this.state.aim,
                faceimpact: this.state.faceimpact,
                pathval: this.state.path,
                contact: this.state.contact,
                launch: this.state.launch,
                facepath: this.state.facepath,
                acceleration: this.state.acceleration,
                drills: this.state.drills,
                reportname: this.state.reportname,
                fileupl: this.state.selectedFile,
            },
            oldfiles: this.props.particularsamlabreport.tsr_filename,
            id: this.props.particularsamlabreport.tsrID,

        };

        this.props.editSamLabReport(data);
        setTimeout(() => {
            this.props.onClick();
        }, 2000);
    };


    onFileChange(event) {
        const files = event.target.files;
        for (let i = 0; i < files.length; i++) {
            const element = files[i];

            this.convertBase64(element).then(result => this.setState({
                selectedFile: [...this.state.selectedFile, result]
            }));
        }
    }


    convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    handleNumberic(e) {
        if (!/[0-9,.]/.test(e.key)) {
            e.preventDefault();
        }
    }

    static propTypes = {
        classes: PropTypes.object,
        prev: PropTypes.number,
    };

    render() {
        const { particularsamlabreport, loading } = this.props;
        const allfile = particularsamlabreport ? particularsamlabreport.tsr_filename || '' : '';

        if (allfile === '') {
            var exfiles = [];
            var filecnt = 0;
            console.log(exfiles, "exfiles")
        } else {
            var exfiles = allfile.split(',');
            var filecnt = exfiles.length;
        }

        const styles = {
            subheading: {
                fontWeight: "bold"
            }
        }

        return (
            <div>
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-sm-12 col-md-4">
                            <RctCollapsibleCard heading="SAM LAB DETAILS EDIT">
                                <div className="float-right">
                                    <button type="button" className="mr-3 mb-3 btn btn-outline-warning " onClick={this.props.onClick}>Back</button>
                                </div>
                                <div className="table-responsive">
                                    <Table hover bordered striped>
                                        <tbody>
                                            <tr>
                                                <td>STUDENT</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="student"
                                                        value={this.state.studentName}
                                                        disabled
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>DATE</td>
                                                <td>
                                                    <DatePicker
                                                        className="form-control"
                                                        id="seldate"
                                                        name="seldate"
                                                        autoComplete="off"
                                                        required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>SETUP</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="setup"
                                                        value={this.state.setup}
                                                        onChange={(e) => this.setState({ setup: e.target.value })}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>AIM PERCEPTION</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="aimperception"
                                                        value={this.state.aimperception}
                                                        onChange={(e) => this.setState({ aimperception: e.target.value })}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>AIM</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="aim"
                                                        value={this.state.aim}
                                                        onChange={(e) => this.setState({ aim: e.target.value })}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>FACE AT IMPACT</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="faceimpact"
                                                        value={this.state.faceimpact}
                                                        onChange={(e) => this.setState({ faceimpact: e.target.value })}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>PATH</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="path"
                                                        value={this.state.path}
                                                        onChange={(e) => this.setState({ path: e.target.value })}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>CONTACT</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="contact"
                                                        value={this.state.contact}
                                                        onChange={(e) => this.setState({ contact: e.target.value })}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>LAUNCH</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="launch"
                                                        value={this.state.launch}
                                                        onChange={(e) => this.setState({ launch: e.target.value })}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>ACCELERATION PROFILE</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="acceleration"
                                                        value={this.state.acceleration}
                                                        onChange={(e) => this.setState({ acceleration: e.target.value })}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>DRILLS</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="drills"
                                                        value={this.state.drills}
                                                        onChange={(e) => this.setState({ drills: e.target.value })}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>REPORT NAME</td>
                                                <td>
                                                    <Input
                                                        type="text"
                                                        name="reportname"
                                                        value={this.state.reportname}
                                                        onChange={(e) => this.setState({ reportname: e.target.value })}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>UPLOAD FILES</td>
                                                <td>
                                                    <input type="file" name="fileupl" id="fileupl" onChange={(e) => this.onFileChange(e)} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group">
                                        <input type="submit" onClick={this.handleFormSubmit} className="mr-3 mb-3 btn btn-outline-primary" />
                                    </div>
                                </div>
                            </RctCollapsibleCard>
                        </div>
                        <div className="col-sm-12 col-md-8" ref={this.nodeRef}>
                            <CarouselProvider
                                naturalSlideWidth={this.state.widthProportion}
                                naturalSlideHeight={this.state.heightProportion}
                                totalSlides={filecnt}
                            >
                                <div className="sdfsdf">
                                    <div className="text-center" style={{ marginTop: "-30px" }}>
                                        {exfiles.map((uptval, idx) => (
                                            <Dot className="text-center" slide={idx}>{idx + 1}</Dot>
                                        ))}
                                    </div>
                                </div>
                                <Slider>
                                    {exfiles.map((uptval, idx) => (
                                        <Slide index={idx}>
                                            <RctCollapsibleCard>
                                                <iframe src={AppConfig.apiurl + '/theme/img/samlab/' + uptval} width="100%" height={600}></iframe>
                                            </RctCollapsibleCard>
                                        </Slide>
                                    ))}
                                </Slider>
                            </CarouselProvider>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ samlabreport }) => {
    const { particularsamlabreport, loading } = samlabreport;
    return { particularsamlabreport, loading };
}

export default connect(mapStateToProps, { editSamLabReport })(EditForm);
